import { useNavigate, useLocation } from "react-router-dom";

const TabNav = ({ activeTab, setActiveTab, tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (tabName, param) => {
    setActiveTab(tabName);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", param);
    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true }
    );
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        marginTop: "12px",
        marginLeft: "2px",
        gap: "4px",
      }}
    >
      {tabs.map(({ name, param, badgeContent }) => (
        <h5
          key={name}
          style={{
            width: `${100 / tabs.length}%`,
            textAlign: "center",
            padding: "8px 0",
            cursor: "pointer",
            transition: "all 0.2s ease",
            backgroundColor: activeTab === name ? "#967cf3" : "#f3f4f6",
            color: activeTab === name ? "#ffffff" : "#374151",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            position: "relative",
          }}
          onMouseOver={(e) => {
            if (activeTab !== name) e.target.style.backgroundColor = "#e5e7eb";
          }}
          onMouseOut={(e) => {
            if (activeTab !== name) e.target.style.backgroundColor = "#f3f4f6";
          }}
          onClick={() => handleTabClick(name, param)}
        >
          {name}
          {badgeContent > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-10px",
                right: "10px",
                backgroundColor: "#d32f2f",
                color: "#ffffff",
                borderRadius: "50%",
                padding: "2px 6px",
                fontSize: "12px",
                lineHeight: "1",
              }}
            >
              {badgeContent}
            </span>
          )}
        </h5>
      ))}
    </div>
  );
};

export default TabNav;